module.exports = __webpack_public_path__ + "img/Logo.4b95ed72.png";